import { render } from "./StudentVocPracticeList.vue?vue&type=template&id=7154c94f"
import script from "./StudentVocPracticeList.vue?vue&type=script&lang=js"
export * from "./StudentVocPracticeList.vue?vue&type=script&lang=js"

import "./StudentVocPracticeList.vue?vue&type=style&index=0&id=7154c94f&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__